module.exports = __webpack_public_path__ + "img/Solar-Space_symbol_8.de4a4963.png";